import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import createExportThunk from "slices/captureDashboard/createExportThunk";
import { selectFilters } from "slices/captureDashboard/selectors";
import { resolvePeriod } from "utils/reportingPeriod";

const BASE_URL = "/api/capture-dashboard/widgets/time-in-stage";
const CSV_FILENAME = "Time in Stage.csv";
const PDF_FILENAME = "Time in Stage.pdf";

export const fetchTimeInStage = createAsyncThunk(
  "timeInStage/fetch",
  async (_, { getState }) => {
    const filters = selectFilters(getState());
    const { periodStart, periodEnd } = resolvePeriod(filters);

    const { data } = await localhost.get(BASE_URL, {
      params: { periodStart, periodEnd },
    });
    return data;
  },
);

export const exportTimeInStageCsv = createExportThunk(BASE_URL, "csv", CSV_FILENAME);
export const exportTimeInStagePdf = createExportThunk(BASE_URL, "pdf", PDF_FILENAME);
